export const getInitialTemplate = () => {
    try {
        const analysis = require.context("components/config/dashboard-templates/Templates/", true, /\.json$/u);
        return analysis?.keys().reduce((prev, curr) => {
            const analysisData = analysis(curr);
            if (analysisData.type) {
                prev[analysisData.type] = {};
            }
            return prev;
        }, {}) ?? {};
    }
    catch {
        return {};
    }
};
export const getLightPortfolioAnalyticsTemplate = () => {
    try {
        const preInvestmentAnalysis = require.context("components/config/dashboard-templates/PreinvestmentAnalytics/Templates/", true, /\.json$/u);
        const loadedPreInvestmentAnalysis = preInvestmentAnalysis?.keys().reduce((prev, curr) => {
            const analysisData = preInvestmentAnalysis(curr);
            if (analysisData.type) {
                prev[analysisData.type] = { ...analysisData,
                    analysis: analysisData.analysis?.map((e) => ({ ...e, isDefault: true })) };
            }
            return prev;
        }, {}) ?? {};
        const analysis = require.context("components/config/dashboard-templates/Templates/", true, /\.json$/u);
        const loadedAnalysis = analysis?.keys().reduce((prev, curr) => {
            const analysisData = analysis(curr);
            if (analysisData.type) {
                prev[analysisData.type] = { ...analysisData,
                    analysis: analysisData.analysis?.map((e) => ({ ...e, isDefault: true })) };
            }
            return prev;
        }, {}) ?? {};
        return { ...loadedAnalysis, ...loadedPreInvestmentAnalysis };
    }
    catch {
        return {};
    }
};
export const getDefaultTemplate = (hasLightPortfolioAnalytics = false) => {
    if (hasLightPortfolioAnalytics) {
        return getLightPortfolioAnalyticsTemplate();
    }
    try {
        const analysis = require.context("components/config/dashboard-templates/Templates/", true, /\.json$/u);
        return analysis?.keys().reduce((prev, curr) => {
            const analysisData = analysis(curr);
            if (analysisData.type) {
                prev[analysisData.type] = { ...analysisData,
                    analysis: analysisData.analysis?.map((e) => ({ ...e, isDefault: true })) };
            }
            return prev;
        }, {}) ?? {};
    }
    catch {
        return {};
    }
};
